module.exports = __webpack_public_path__ + "img/avito.1e8bb808.svg";